class @ContainerProfile
  constructor: ->
    $(".select2-grades, .select2-subjects").select2
      theme: 'bootstrap'

window.ContainerProfile = @ContainerProfile;
